import api from "./api"
import { getStoredShipper } from "../../src/constants/utils"

const CALENDARVIEW_ROOT = "api/ListLogisticPlans"
const PLANNING_COUNT_ROOT = "planCount"

const calendarviewApi = {
    fetchPlanShipmentData(
        startDate,
        endDate,
        LEStatus,
        filterType,
        filterValues
    ) {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        return api.post(
            `${CALENDARVIEW_ROOT}`,
            {
                ApiStandardParameters: {
                    Road: STORED_RAILROAD_NAME,
                    Shipper: STORED_SHIPPER_NAME,
                },
                Filter: {
                    FilterValues: filterValues,
                    FilterType: filterType,
                    EtaStartDate: startDate,
                    EtaEndDate: endDate,
                    LoadEmptyStatus: LEStatus,
                },
            },
            "STAGING"
        )
    },
    fetchTotalPlannedCar(selectedPlanName) {
        const { STORED_SHIPPER_NAME_ENCODED, STORED_RAILROAD_NAME_ENCODED } =
            getStoredShipper()

        return api.get(
            `${PLANNING_COUNT_ROOT}/${STORED_RAILROAD_NAME_ENCODED}/${STORED_SHIPPER_NAME_ENCODED}/${selectedPlanName}`,
            "ROOT"
        )
    },
    updatePlanCount(modifiedData) {
        return api.post(`planCount/`, modifiedData, "ROOT")
    },
}

export default calendarviewApi
